// extracted by mini-css-extract-plugin
export var leftAlign = "_l-2";
export var popper = "_l-0";
export var subtitle = "_l-1";